export default "__VITE_ASSET__CzwLqsZl__"